import { render, staticRenderFns } from "./xfAccount.vue?vue&type=template&id=ef665dce&"
import script from "./xfAccount.vue?vue&type=script&lang=js&"
export * from "./xfAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports